import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.ConfirmationArea");
log.setLevel(log.levels.WARN);

const ConfirmationArea = function () {
    var {Modal} = window.f_mtac_theme;
    var confirmation_area_modal;
    var $confirmation_area = document.getElementById("confirmation_area");

    this.interact = function ({title = "", tip1 = "", tip2 = "", accept, backdrop = true}) {
        confirmation_area_modal = Modal.getOrCreateInstance($confirmation_area, {backdrop});
        var result = false;

        log.debug("ConfirmationArea.interact", {title, tip1, tip2});

        // Prepare the view
        $("#confirmation_area .modal-title").html(title);
        $("#confirmation_area p.tip1").html(tip1); // AGPOC-4659: use .html() for special characters
        $("#confirmation_area p.tip2").html(tip2);
        if (tip2 !== "") {
            $("#confirmation_area .zone_2").show();
        } else {
            $("#confirmation_area .zone_2").hide();
        }
        if (accept === true) {
            $("#confirmation_area button[data-method=cancel]").text(global.internationalization.text("global.Leave"));
            $("#confirmation_area button[data-method=ok]").text(global.internationalization.text("global.Accept"));
        } else {
            $("#confirmation_area button[data-method=cancel]").text(global.internationalization.text("global.Cancel"));
            $("#confirmation_area button[data-method=ok]").text(global.internationalization.text("global.Validate"));
        }

        // User actions handlers
        let handlers = {
            ok: () => {
                result = true;
                confirmation_area_modal.hide();
            },
            cancel: () => {
                result = false;
                confirmation_area_modal.hide();
            },
            close: () => {
                result = false;
                confirmation_area_modal.hide();
            }
        };

        $("body").on("click.confirmation_area.btn", "#confirmation_area .btn", (event) => {
            log.debug("Confirmation event:", $(event.currentTarget).data("method"));
            handlers[$(event.currentTarget).data("method")]();
        });

        return new Promise((resolve) => {
            let interaction_end = () => {
                log.debug("Confirmation modal closed with result:", result);
                $confirmation_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("body").off("click.confirmation_area.btn", "#confirmation_area .btn");
                resolve(result);
            };
            $confirmation_area.addEventListener("hidden.bs.modal", interaction_end);
            confirmation_area_modal.show();
        });
    };
};
export default new ConfirmationArea();
